<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <span slot="button" v-if="permissionChecker('AnnouncementScope.Create') && this.paramsX.status == 1">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
      <span slot="tag">
        <label style="color: red;font-size: 14px;">说明：如果不设置范围，则发送给全部经销商</label>
      </span>
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!permissionChecker('AnnouncementScope.Delete') && this.paramsX.isActive == false">删除</a>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-AnnouncementScope-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-AnnouncementScope-add>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageAnnouncementScopeAdd from "./AddScope";
import config from "@/config";
import { setTimeout } from "timers";
let dealerTypeOptions = [];
let organizationOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageAnnouncementScopeAdd
  },
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [
        {
          type: "select",
          key: "organizationId",
          name: "销售组织",
          options: organizationOptions
        },
        {
          type: "select",
          key: "dealerType",
          name: "客户类型",
          options: dealerTypeOptions
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "销售组织",
          dataIndex: "organizationName"
        },
        {
          title: "客户类型",
          dataIndex: "dealerTypeName",
          width: 300
        },
        {
          title: "修改时间",
          width: 180,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { organizationId: null, dealerType: null },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      announcementId: 0,
      title: ""
    };
  },
  async mounted() {
    this.announcementId = this.paramsX.id;
    if (this.paramsX.status == 2) {
      this.columns = this.columns.filter(a => a.dataIndex != "action");
    }
    this.GetDealerTypeOptions();
    this.GetOrganizationOptions();
    this.getDatas(this.filterdata);
  },
  methods: {
    async GetDealerTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 3 });
      if (dictionary) {
        dealerTypeOptions = [];
        dictionary.forEach(a => {
          dealerTypeOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    async GetOrganizationOptions() {
      let org = await api.GetOrganizationSelect();
      if (org) {
        organizationOptions = [];
        org.forEach(a => {
          organizationOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.organizationId = p.values.organizationId;
      this.filterdata.dealerType = p.values.dealerType;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },

    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑";
      } else if (type == 2) {
        this.title = "详情";
        this.isabl = true;
      } else {
        this.title = "新增";
      }
      this.params = Object.assign(
        { isShow: this.isabl, announcementId: this.announcementId },
        record
      );
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelAnnouncementScope({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      options.announcementId = this.announcementId;
      let data = await api.GetAnnouncementScopeList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Information/Announcement/ScopeList.vue